import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ClientState {
    current: any | null;
}

const initialState: ClientState = {
    current: null,
};

export const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {
        setClient(state, action: PayloadAction<any>) {
            state.current = action.payload;
        },
    },
});

export const { setClient } = clientSlice.actions;
export const selectClient = (state: any) => state.client.current;
export default clientSlice.reducer;
